import { skipToken } from '@tanstack/react-query'
import { getAddress, isAddress } from 'viem'

import type { UserLendPositions } from '@/lib/procedures/userPositions.contract'

import { orpc } from '@/lib/orpc/client'

export type UserLendPosition = UserLendPositions['items'][number]
export type UserLendPositionFacets = UserLendPositions['facets']
export type UserLendPositionsOrderBy = 'supplyAssetsUsd' | 'netSupplyApy'
export type UserLendPositionsOrderDirection = 'asc' | 'desc'

/**
 * The `user.lendPositions` query the Portfolio lend table and the nav badge share. The order is
 * part of the key: the badge asks for the table's default order so both read one cache entry.
 */
export function userLendPositionsQueryOptions({
  userAddress,
  orderBy,
  orderDirection,
  enabled = true
}: {
  userAddress: string | undefined
  orderBy?: UserLendPositionsOrderBy
  orderDirection?: UserLendPositionsOrderDirection
  enabled?: boolean
}) {
  return orpc.user.lendPositions.queryOptions({
    input:
      enabled && userAddress && isAddress(userAddress, { strict: false })
        ? { userAddress: getAddress(userAddress), orderBy, orderDirection }
        : skipToken,
    staleTime: 60 * 1000
  })
}
